<template>
  <div class="header-bar">
    <div class="header-icon" @click="handleHome">
      <img :src="require('@/assets/home/header-name-icon.png')" />
      <div style="font-weight: 600;">浙大投资协会</div>
    </div>
    <div class="login-btn" v-if="model.showStatus==='1'">登录/注册</div>
    <div class="user-btn" v-if="model.showStatus==='2'">
      <a-dropdown trigger="hover">
        <a-button type="text" class="drop-btn">
          <div class="user-menu-name">
            <img :src="require('@/assets/home/user-icon.jpg')" />
            <div class="umn-bar">
              <div class="umn-name">{{ model.username }}</div>
              <!-- <div class="umn-phone">{{ model.phone }}</div> -->
            </div>
          </div>
          <img :src="require('@/assets/user/user-drop.png')" style="width:12px;margin-left:4px" />
        </a-button>
        <template #content>
          <!-- <a-doption>
            <template #icon>
              <img :src="require('@/assets/user/user-check.png')" style="width:16px" />
            </template>
            <template #default>打卡记录</template>
          </a-doption>-->
          <a-doption @click="handleInvite">
            <template #icon>
              <img :src="require('@/assets/user/user-invite.png')" style="width:16px" />
            </template>
            <template #default>邀请概要</template>
          </a-doption>
          <a-doption @click="handleUserInfo">
            <template #icon>
              <img :src="require('@/assets/user/user-my.png')" style="width:16px" />
            </template>
            <template #default>个人信息</template>
          </a-doption>
          <div class="user-menu-divide"></div>
          <a-doption @click="handleLogout">
            <template #icon>
              <img :src="require('@/assets/user/user-logout.png')" style="width:16px" />
            </template>
            <template #default>退出登录</template>
          </a-doption>
        </template>
      </a-dropdown>
    </div>
  </div>
</template>
    
<script setup>
import { getCurrentInstance, reactive } from "vue";
// import { useRouter } from "vue-router";
// const router = useRouter();
const post = getCurrentInstance().appContext.config.globalProperties.post;
const get = getCurrentInstance().appContext.config.globalProperties.get;
const storageLabel = getCurrentInstance().appContext.config.globalProperties.storageLabel;
import { useRouter } from "vue-router";
const router = useRouter();

const model = reactive({
  showStatus: "",
  username: "",
  phone: "",
});
function getUserInfo() {
  //是否已经登录
  if (localStorage.getItem(storageLabel() ) !== null) {
    //获取用户信息
    get(`/userInfo/info/${localStorage.getItem(storageLabel() )}`).then((res) => {
      if (res && res.success) {
        model.username = res.data.nickName;
        model.phone = res.data.phone;
        model.showStatus = "2";
      }
    });
  } else {
    if (router.currentRoute.value.name === "home") {
      //如果当前是首页
      model.showStatus = "1";
    } else {
      handleHome();
    }
  }
}
getUserInfo();
//返回首页
function handleHome() {
  router.push("/web/main");
}
//邀请界面
function handleInvite() {
  router.push("/web/invite");
}
//个人信息
function handleUserInfo() {
  router.push("/web/userInfo");
}
//退出登录
function handleLogout() {
  post("/userInfo/logout", {}).then(() => {
    localStorage.removeItem(storageLabel() );
    location.reload();
  });
}
</script>
<style>
.user-menu-divide {
  border-top: 1px solid #e5e5e5;
  width: 80%;
  margin: 0 auto;
}
</style>
<style lang="scss" scoped>
.header-bar {
  background-color: #fff;
  height: 50px;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #e5e5e5;
  .header-icon {
    display: flex;
    align-items: center;
    padding: 16px 25px;
    cursor: pointer;
    img {
      height: 30px;
      margin-right: 12px;
    }
  }
  .login-btn {
    width: 120px;
    height: 100%;
    background-color: #3379f1;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    cursor: pointer;
  }
  .user-btn {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    .user-menu-name {
      font-weight: 500;
      display: flex;
      align-items: center;
      img {
        height: 30px;
        border-radius: 50%;
        margin-right: 8px;
      }
      .umn-bar {
        max-width: 200px;
        .umn-name {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .umn-phone {
          font-size: 12px;
          color: #666666;
        }
      }
    }
    .drop-btn {
      color: #333;
      height: 50px;
      margin-right: 10px;
    }
  }
}
</style>
    